<script>
    export default {
        props: {
            file: Object
        },
        methods: {
            randomCache() {
                const value=Math.floor(Math.random() * 100000000); 
                return value;
            },
            async showBigPreview() {
                this.$store.commit('SELECT_FILE', this.file);
                this.$store.commit('IS_SHOW_BIG_PREVIEW', true);
            }
        }
    }
</script>


<template>
    <div 
        class="image_preview"
        @click="showBigPreview"    
    >
        <img :src="`${file.imagePreview}?cache=${randomCache()}`">
    </div>    
</template>


<style scoped>
    .image_preview {
        flex: 0 0 300px;

        border-radius: 10px;
        margin: 5px;

        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;
    }
    .image_preview:hover {
        background-color: var(--image-hover);
    }

    img {
        width: 100%;
        height: auto;
        background-image: url('@/../assets/images/transperent.jpg');
    }
</style>